<template>
    <vue-select
        :value="value"
        :options="users || []"
        :get-option-label="(option) => { return option.profile ? (option.profile.marunage_user_id + ': ' + option.nickname) : '' }"
        :size="size"
        :reduce="v => v.profile.marunage_user_id"
        :filter="filter"
        @input="input"
        @search="fetchOptions"

        append-to-body
        :calculate-position="withPopper"
        placeholder="アカウントを選択してください"
        :clearable="false"
        >
    </vue-select>
</template>

<script>
import { mapGetters } from 'vuex'
import Fuse from 'fuse.js'
import { createPopper } from '@popperjs/core'

export default {
    components: {
    },
    props: {
        value: {
            type: String,
            required: false,
            default: null,
        },
        size: {
            type: String,
            required: false,
            default: 'sm',
        },
        me: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            users: [],
        }
    },
    computed: {
        ...mapGetters([
        ]),
    },
    async mounted() {
        this.fetchOptions()
    },
    methods: {
        fetchOptions(search, loading) {
            this.users.splice(0)
            this.$store
                .dispatch('user/index', {
//                    level: 200,
                    group: true,
                    SILENT: true,
                })
                .then((response) => {
                    if (this.me) {
                        this.users.push(
                            this.$store.state.auth.user
                        )
                    }
                    response.data.data.hits.forEach((hit) => {
                        if (!hit.profile.marunage_user_id) {
                            return
                        }
                        const length = this.users.filter((user) => {
                            return user.id === hit.id
                        }).length
                        if (length) {
                            return
                        }
                        this.users.push(hit)
                    })
//                    this.users.push(...response.data.data.hits)
                })
                .catch((error) => {
                })
        },
        filter(options, search) {
            const fuse = new Fuse(options, {
                keys: [ 'marunage_user_id', 'nickname', ],
                shouldSort: true,

                tokenize: true,
//                ignoreLocation: true,

                includeMatches: true,
                minMatchCharLength: 1,
                threshold: 0.9,
            })
setTimeout(() => {
    const dropdownList = document.querySelector('ul.vs__dropdown-menu')
    if (dropdownList) {
        console.log(dropdownList.scrollTop = 0)
    }
} , 1)
            return search.length
                ? fuse.search(search).map(({ item }) => item)
                : fuse.list
        },
        input(value) {
            this.$emit('input', value)
        },

        withPopper(dropdownList, component, { width }) {
            /**
             * We need to explicitly define the dropdown width since
             * it is usually inherited from the parent with CSS.
             */
            dropdownList.style.width = width
            dropdownList.style.height = '350px'

            /**
             * Here we position the dropdownList relative to the $refs.toggle Element.
             *
             * The 'offset' modifier aligns the dropdown so that the $refs.toggle and
             * the dropdownList overlap by 1 pixel.
             *
             * The 'toggleClass' modifier adds a 'drop-up' class to the Vue Select
             * wrapper so that we can set some styles for when the dropdown is placed
             * above.
             */
            const vm = this
            const popper = createPopper(component.$refs.toggle, dropdownList, {
                placement: 'bottom',
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, -1],
                        },
                    },
                    {
                        name: 'toggleClass',
                        enabled: true,
                        phase: 'write',
                        fn({ state }) {
                            component.$el.classList.toggle(
                                'drop-up',
                                state.placement === 'top'
                            )
                        },
                    },
                ],
            })
            
            /**
             * To prevent memory leaks Popper needs to be destroyed.
             * If you return function, it will be called just before dropdown is removed from DOM.
             */
            return () => popper.destroy()
        },
    },
}
</script>

<style>
.v-select.drop-up.vs--open .vs__dropdown-toggle {
    border-radius: 0 0 4px 4px;
    border-top-color: transparent;
    border-bottom-color: rgba(60, 60, 60, 0.26);
}

[data-popper-placement='top'] {
    border-radius: 4px 4px 0 0;
    border-top-style: solid;
    border-bottom-style: none;
    box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15);
}
</style>

<style>
.vs__dropdown-menu {
    z-index: 2000;
}
.vs__search {
    color: #6c757d;
}
</style>

